import { render } from "./QuestionSection.vue?vue&type=template&id=64f01280"
import script from "./QuestionSection.vue?vue&type=script&lang=js"
export * from "./QuestionSection.vue?vue&type=script&lang=js"

import "./QuestionSection.vue?vue&type=style&index=0&id=64f01280&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__